import { render } from "./ChatIcon.vue?vue&type=template&id=b0496d6a"
import script from "./ChatIcon.vue?vue&type=script&lang=js"
export * from "./ChatIcon.vue?vue&type=script&lang=js"

import "./ChatIcon.vue?vue&type=style&index=0&id=b0496d6a&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__